/**
 * Reports the embed page's content height to the parent window so it can
 * resize the cross-origin <iframe> accordingly (height cannot be read from
 * the parent side across origins).
 */
export default class MerchSliderEmbed {
    private static readonly ALLOWED_TARGET_ORIGINS: string[] = [
        'https://app.povidej-posloucham.orb.local',
        'https://povidejposloucham.cz',
        'https://www.povidejposloucham.cz',
    ];

    private static readonly PERIODIC_SEND_INTERVAL_MS = 5000;

    static init(): void {
        if (!document.body.classList.contains('layout-embed')) {
            return;
        }

        if (!window.parent || window.parent === window) {
            return;
        }

        const targetOrigin = MerchSliderEmbed.resolveTargetOrigin();
        if (!targetOrigin) {
            return;
        }

        const sendHeight = (): void => {
            const slider = document.querySelector('.product-slider');
            const height = slider ? slider.getBoundingClientRect().height : document.documentElement.scrollHeight;

            window.parent.postMessage({ height }, targetOrigin);
        };

        window.addEventListener('load', sendHeight);
        window.addEventListener('resize', sendHeight);

        new ResizeObserver(sendHeight).observe(document.body);

        const sliderInner = document.querySelector('.js-product-slider-init .product-slider__inner');
        if (sliderInner) {
            new MutationObserver(sendHeight).observe(sliderInner, {
                attributes: true,
                attributeFilter: ['style', 'class'],
                childList: true,
                subtree: true,
            });
        }

        // Sliders (tiny-slider) can settle their layout after a debounce/transition
        // that ResizeObserver/MutationObserver don't reliably catch, so poll as a fallback.
        setInterval(sendHeight, MerchSliderEmbed.PERIODIC_SEND_INTERVAL_MS);

        sendHeight();
    }

    private static resolveTargetOrigin(): string | null {
        if (!document.referrer) {
            return null;
        }

        let referrerOrigin: string;
        try {
            referrerOrigin = new URL(document.referrer).origin;
        } catch {
            return null;
        }

        return MerchSliderEmbed.ALLOWED_TARGET_ORIGINS.find((allowedOrigin) => allowedOrigin === referrerOrigin) ?? null;
    }
}
